import * as React from 'react';
const SvgLogo = (props) => (
  <svg
    width={164}
    height={164}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_5915_281488"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={164}
      height={164}
    >
      <path
        d="M81.7712 163.691C126.932 163.691 163.542 127.048 163.542 81.8455C163.542 36.6436 126.932 0 81.7712 0C36.6102 0 0 36.6436 0 81.8455C0 127.048 36.6102 163.691 81.7712 163.691Z"
        fill="#F5F7FF"
      />
    </mask>
    <g mask="url(#mask0_5915_281488)">
      <path
        d="M81.7712 163.691C126.932 163.691 163.542 127.048 163.542 81.8455C163.542 36.6436 126.932 0 81.7712 0C36.6102 0 0 36.6436 0 81.8455C0 127.048 36.6102 163.691 81.7712 163.691Z"
        fill="#F5F7FF"
      />
      <path
        d="M79.6344 138.116C124.795 138.116 161.405 101.473 161.405 56.2713C161.405 11.0694 124.795 -25.5742 79.6344 -25.5742C34.4735 -25.5742 -2.13672 11.0694 -2.13672 56.2713C-2.13672 101.473 34.4735 138.116 79.6344 138.116Z"
        fill="#F5F7FF"
      />
      <path
        d="M79.6344 67.2113C124.795 67.2113 161.405 30.5684 161.405 -14.6337C161.405 -59.8357 124.795 -96.4792 79.6344 -96.4792C34.4735 -96.4792 -2.13672 -59.8357 -2.13672 -14.6337C-2.13672 30.5684 34.4735 67.2113 79.6344 67.2113Z"
        fill="#F5F7FF"
      />
    </g>
    <path
      opacity={0.12}
      d="M140.176 100.257C149.36 100.257 156.806 107.702 156.806 116.887C156.806 126.071 149.36 133.517 140.176 133.517C130.991 133.517 123.546 126.071 123.546 116.887C123.546 107.702 130.991 100.257 140.176 100.257Z"
      fill="white"
      stroke="white"
      strokeWidth={2.12295}
    />
    <path
      d="M140.176 109.81V116.887M140.176 123.963H140.193M157.867 116.887C157.867 126.657 149.946 134.578 140.176 134.578C130.405 134.578 122.484 126.657 122.484 116.887C122.484 107.116 130.405 99.1953 140.176 99.1953C149.946 99.1953 157.867 107.116 157.867 116.887Z"
      stroke="white"
      strokeWidth={2.12295}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M103.965 40.794L39.7364 81.5063L34.2129 72.7922V65.2832C34.2129 62.5494 35.5972 60.0015 37.8909 58.5137L75.2268 34.2869C80.915 30.5957 88.2419 30.595 93.9308 34.2854L103.965 40.794Z"
      fill="url(#paint0_linear_5915_281488)"
    />
    <path
      d="M93.3553 33.9292C93.5484 34.0436 93.74 34.1631 93.9302 34.2862L123.068 53.187L50.8208 98.9819L39.7344 81.4918L92.7571 47.8179C97.7794 44.628 97.9994 37.4527 93.3553 33.9292Z"
      fill="url(#paint1_linear_5915_281488)"
    />
    <path
      d="M93.3553 33.9292C93.5484 34.0436 93.74 34.1631 93.9302 34.2862L123.068 53.187L50.8208 98.9819L39.7344 81.4918L92.7571 47.8179C97.7794 44.628 97.9994 37.4527 93.3553 33.9292Z"
      fill="url(#paint2_linear_5915_281488)"
    />
    <path
      d="M79.6456 107.726L50.8213 98.9824L112.106 60.1347C117.267 56.8632 117.254 49.328 112.081 46.0748L111.805 45.9014L112.6 46.3954L131.251 58.4946C133.546 59.9824 134.93 62.531 134.93 65.2655V72.5326L79.6456 107.726Z"
      fill="url(#paint3_linear_5915_281488)"
    />
    <path
      d="M79.6456 107.726L50.8213 98.9824L112.106 60.1347C117.267 56.8632 117.254 49.328 112.081 46.0748L111.805 45.9014L112.6 46.3954L131.251 58.4946C133.546 59.9824 134.93 62.531 134.93 65.2655V72.5326L79.6456 107.726Z"
      fill="url(#paint4_linear_5915_281488)"
    />
    <path
      d="M93.9308 34.2854C88.2419 30.595 80.915 30.5957 75.2261 34.2869L37.8909 58.5137C35.5972 60.0015 34.2129 62.5494 34.2129 65.2832V65.6504C34.3032 68.395 35.7473 70.924 38.0803 72.3951L84.5034 101.662L131.044 72.4395C133.461 70.9218 134.928 68.2683 134.928 65.4143V72.5335L134.929 65.2657C134.929 62.5312 133.544 59.9833 131.251 58.4947L93.9308 34.2854Z"
      fill="url(#paint5_radial_5915_281488)"
    />
    <path
      d="M76.3196 132.173H117.438C127.096 132.173 134.925 124.344 134.925 114.686V65.4146C134.925 68.2685 133.458 70.9221 131.041 72.4398L69.8795 110.843C66.5803 112.915 64.5781 116.537 64.5781 120.433C64.5789 126.917 69.835 132.173 76.3196 132.173Z"
      fill="#DEE4FF"
    />
    <path
      d="M76.3196 132.173H117.438C127.096 132.173 134.925 124.344 134.925 114.686V65.4146C134.925 68.2685 133.458 70.9221 131.041 72.4398L69.8795 110.843C66.5803 112.915 64.5781 116.537 64.5781 120.433C64.5789 126.917 69.835 132.173 76.3196 132.173Z"
      fill="url(#paint6_radial_5915_281488)"
    />
    <path
      d="M76.3196 132.173H117.438C127.096 132.173 134.925 124.344 134.925 114.686V65.4146C134.925 68.2685 133.458 70.9221 131.041 72.4398L69.8795 110.843C66.5803 112.915 64.5781 116.537 64.5781 120.433C64.5789 126.917 69.835 132.173 76.3196 132.173Z"
      fill="url(#paint7_radial_5915_281488)"
    />
    <path
      d="M93.038 132.169H51.6926C42.0349 132.169 34.2061 124.341 34.2061 114.683V65.3774C34.2061 68.2263 35.6676 70.8755 38.0771 72.3946L99.1787 110.915C102.524 113.024 104.552 116.703 104.552 120.657C104.551 127.015 99.3965 132.169 93.038 132.169Z"
      fill="url(#paint8_radial_5915_281488)"
    />
    <path
      d="M93.038 132.169H51.6926C42.0349 132.169 34.2061 124.341 34.2061 114.683V65.3774C34.2061 68.2263 35.6676 70.8755 38.0771 72.3946L99.1787 110.915C102.524 113.024 104.552 116.703 104.552 120.657C104.551 127.015 99.3965 132.169 93.038 132.169Z"
      fill="url(#paint9_linear_5915_281488)"
    />
    <path
      d="M37.7063 79.0044H64.2858C69.308 79.0044 73.3788 83.0751 73.3788 88.0974V114.677C73.3788 119.699 69.308 123.77 64.2858 123.77H37.7063C32.684 123.77 28.6133 119.699 28.6133 114.677V88.0974C28.6133 83.0751 32.684 79.0044 37.7063 79.0044Z"
      fill="url(#paint10_radial_5915_281488)"
    />
    <path
      d="M37.7063 79.0044H64.2858C69.308 79.0044 73.3788 83.0751 73.3788 88.0974V114.677C73.3788 119.699 69.308 123.77 64.2858 123.77H37.7063C32.684 123.77 28.6133 119.699 28.6133 114.677V88.0974C28.6133 83.0751 32.684 79.0044 37.7063 79.0044Z"
      fill="url(#paint11_radial_5915_281488)"
    />
    <path
      d="M50.8818 114.257C47.1798 114.257 44.1415 113.099 41.7655 110.783C39.3895 108.468 38.2012 105.445 38.2012 101.717C38.2012 97.7798 39.407 94.5958 41.8187 92.1638C44.2311 89.7324 47.3889 88.5171 51.2935 88.5171C54.9831 88.5171 57.9857 89.6807 60.3019 92.0078C62.6306 94.335 63.7949 97.4039 63.7949 101.213C63.7949 105.127 62.5883 108.282 60.1766 110.679C57.7766 113.065 54.6786 114.257 50.8818 114.257ZM50.9889 109.342C53.0064 109.342 54.6305 108.653 55.8604 107.275C57.0903 105.897 57.7052 103.98 57.7052 101.526C57.7052 98.9667 57.1077 96.9755 55.9143 95.551C54.7201 94.1266 53.1259 93.4148 51.1325 93.4148C49.0785 93.4148 47.4246 94.1499 46.1714 95.6203C44.9175 97.0797 44.2909 99.0134 44.2909 101.421C44.2909 103.865 44.9175 105.799 46.1714 107.223C47.4246 108.635 49.0304 109.342 50.9889 109.342Z"
      fill="white"
    />
    <path
      d="M50.8708 114.602C47.1834 114.602 44.156 113.413 41.7888 111.034C39.4223 108.655 38.2383 105.55 38.2383 101.721C38.2383 97.6762 39.4398 94.4055 41.8427 91.9079C44.2456 89.4095 47.3917 88.1606 51.281 88.1606C54.9561 88.1606 57.9478 89.3563 60.2553 91.7468C62.5751 94.1381 63.7344 97.2901 63.7344 101.203C63.7344 105.223 62.5329 108.465 60.1307 110.927C57.7394 113.377 54.653 114.602 50.8708 114.602ZM50.9772 109.553C52.9874 109.553 54.6057 108.845 55.8304 107.43C57.056 106.014 57.668 104.046 57.668 101.524C57.668 98.8952 57.0734 96.85 55.8844 95.3869C54.6946 93.9239 53.1069 93.1924 51.1207 93.1924C49.0741 93.1924 47.4267 93.9472 46.1779 95.4584C44.9291 96.9564 44.3046 98.9433 44.3046 101.417C44.3046 103.927 44.9291 105.913 46.1779 107.376C47.4267 108.828 49.0267 109.553 50.9772 109.553Z"
      fill="white"
    />
    <path
      d="M140.302 95.1011C135.982 95.1011 131.76 96.3787 128.168 98.7725C124.577 101.166 121.778 104.569 120.125 108.55C118.472 112.53 118.039 116.911 118.881 121.137C119.725 125.363 121.804 129.245 124.859 132.291C127.914 135.338 131.804 137.413 136.041 138.254C140.277 139.094 144.67 138.662 148.66 137.014C152.651 135.365 156.061 132.572 158.461 128.99C160.861 125.407 162.142 121.195 162.142 116.887C162.142 114.026 161.577 111.193 160.48 108.55C159.382 105.907 157.773 103.505 155.745 101.482C153.717 99.4589 151.31 97.8542 148.66 96.7593C146.01 95.6645 143.17 95.1011 140.302 95.1011Z"
      fill="#E4626F"
    />
    <path
      opacity={0.12}
      d="M140.176 100.257C149.36 100.257 156.806 107.702 156.806 116.887C156.806 126.071 149.36 133.517 140.176 133.517C130.991 133.517 123.546 126.071 123.546 116.887C123.546 107.702 130.991 100.257 140.176 100.257Z"
      fill="white"
      stroke="white"
      strokeWidth={2.12295}
    />
    <path
      d="M140.176 109.81V116.887M140.176 123.963H140.193M157.867 116.887C157.867 126.657 149.946 134.578 140.176 134.578C130.405 134.578 122.484 126.657 122.484 116.887C122.484 107.116 130.405 99.1953 140.176 99.1953C149.946 99.1953 157.867 107.116 157.867 116.887Z"
      stroke="white"
      strokeWidth={2.12295}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5915_281488"
        x1={45.3693}
        y1={77.2273}
        x2={103.965}
        y2={40.8835}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5F7FF" />
        <stop offset={0.4} stopColor="#EDF0FF" />
        <stop offset={1} stopColor="#BFC3DF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5915_281488"
        x1={65.5366}
        y1={89.6207}
        x2={98.1567}
        y2={37.3885}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BFC3DF" />
        <stop offset={0.5008} stopColor="#EDF0FF" />
        <stop offset={1} stopColor="#9998BD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5915_281488"
        x1={89.3275}
        y1={90.3311}
        x2={53.1117}
        y2={60.822}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.236946} stopColor="#448AFF" stopOpacity={0} />
        <stop offset={0.792113} stopColor="#0032B1" stopOpacity={0.2} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5915_281488"
        x1={84.7189}
        y1={101.694}
        x2={141.953}
        y2={65.0644}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C3CCFF" />
        <stop offset={0.492267} stopColor="#DEE4FF" />
        <stop offset={1} stopColor="#9FAAFF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5915_281488"
        x1={100.876}
        y1={99.5047}
        x2={66.0968}
        y2={69.4097}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C3CCFF" stopOpacity={0} />
        <stop offset={0.669859} stopColor="#C3CCFF" stopOpacity={0.2} />
      </linearGradient>
      <radialGradient
        id="paint5_radial_5915_281488"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(84.5747 33.7292) rotate(-90) scale(75.5493 81.7703)"
      >
        <stop offset={0.568182} stopColor="#275FF0" stopOpacity={0} />
        <stop offset={0.992424} stopColor="#002177" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_5915_281488"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(96.0206 120.725) rotate(-45) scale(32.3766)"
      >
        <stop offset={0.259477} stopColor="#C3CCFF" stopOpacity={0.4} />
        <stop offset={0.908166} stopColor="#C3CCFF" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint7_radial_5915_281488"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(47.1664 144.675) rotate(-52.6577) scale(109.903 99.3805)"
      >
        <stop offset={0.732317} stopColor="#C3CCFF" stopOpacity={0} />
        <stop offset={1} stopColor="#C3CCFF" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_5915_281488"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.3794 91.6834) rotate(123.339) scale(57.9875 150.484)"
      >
        <stop stopColor="#C3CCFF" />
        <stop offset={0.724349} stopColor="#C3CCFF" />
      </radialGradient>
      <linearGradient
        id="paint9_linear_5915_281488"
        x1={27.0949}
        y1={120.614}
        x2={75.9775}
        y2={120.579}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.205882} stopColor="#C3CCFF" />
        <stop offset={0.535} stopColor="#9FAAFF" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="paint10_radial_5915_281488"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.4536 80.7262) rotate(46.9242) scale(58.9276)"
      >
        <stop offset={0.038877} stopColor="#9FAAFF" />
        <stop offset={0.919119} stopColor="#605AFB" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_5915_281488"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(50.996 106.266) rotate(90) scale(31.3358 36.1448)"
      >
        <stop offset={0.557796} stopColor="#0FA5F7" stopOpacity={0} />
        <stop offset={1} stopColor="#74C6FF" stopOpacity={0.501961} />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgLogo;
